import React from 'react';
import IamDetails from './IamDetails';

const OrganizationCard = ({ data }) => {
  return (
    <div className="ResultsArea">
      <div className="Card">
        <div className="SectionTitle">
          <div>
            {`${
              data.env === 'organization'
                ? 'Organization'
                : 'Organization Sandbox'
            } Card`}
            <h1>{data.organization.displayName}</h1>
          </div>
          <div className="logo-container"></div>
        </div>
        <div className="ResultsSection">
          <div className="DeliveryResultsSection">
            <IamDetails iamDetails={data} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationCard;
